import React, { useState, useEffect, useRef } from "react";
import { MiniModalContainer, CloseButton, AproveiteLogo } from "./styles";
import backgroundImage from "./assets/Popup.png";
import { LINKS } from "@constants";

const MiniModalDezAnos = ({ delay = 0 }) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(delay === 0);
  const [isClosed, setIsClosed] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);

  const handleClose = (ev) => {
    ev.stopPropagation();
    setIsVisible(false);
    setTimeout(() => {
      setIsClosed(true);
    }, 500);
  };

  useEffect(() => {
    if (!isClosed && !isVisible && delay > 0) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, delay);
      return () => clearTimeout(timer);
    }

    return undefined;
  }, [delay, isClosed, isVisible]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosit = window.scrollY + window.innerHeight;
      const pageHeig = document.documentElement.scrollHeight;
      const bottomThr = pageHeig - 100;

      setIsAtBottom(scrollPosit >= bottomThr);
    };

    const handleKeyDown = (e) => {
      if (e.key === "Escape") handleClose(e);
    };
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleButtonClick = (e) => {
    e.stopPropagation();
    if (!buttonClicked) {
      setButtonClicked(true);
      window.open(LINKS.miniPopupCampanhaDezAnos, "_blank");
    }
  };

  if (isClosed) return null;

  return (
    <MiniModalContainer
      ref={containerRef}
      backgroundImage={backgroundImage}
      isAtBottom={isAtBottom}
      isVisible={isVisible}
    >
      <CloseButton onClick={handleClose}>&times;</CloseButton>
      <AproveiteLogo onClick={handleButtonClick}>Saiba mais</AproveiteLogo>
    </MiniModalContainer>
  );
};

export default MiniModalDezAnos;
